const inline_hook = {
    general: 'An error occurred while running the inline hook. Please try again later.',
};
export default Object.freeze(inline_hook);
